import { ref } from "vue";
import {
  getParticipantListNotarial,
  addParticipantToNotary,
  updateParticipantNotarial,
} from "../api";

export function useParticipants(uuid) {
  const participants = ref([]);
  const participantsLoading = ref(false);

  async function fetchParticipants() {
    participantsLoading.value = true;
    try {
      const response = await getParticipantListNotarial(uuid.value);
      if (response?.success) {
        participants.value = response?.payload?.items || [];
      }
    } catch (e) {
      console.error("fetchParticipants error:", e);
    } finally {
      participantsLoading.value = false;
    }
  }

  async function addParticipant(participant) {
    const response = await addParticipantToNotary(uuid.value, participant);
    if (response?.success) {
      await fetchParticipants();
    }
    return response;
  }

  async function updateParticipant(participantUuid, payload) {
    const response = await updateParticipantNotarial(
      uuid.value,
      participantUuid,
      payload
    );
    if (response?.success) {
      await fetchParticipants();
    }
    return response;
  }

  return {
    participants,
    participantsLoading,
    fetchParticipants,
    addParticipant,
    updateParticipant,
  };
}
